import React from 'react';
import { FaIcon } from '../common/Icons.jsx';
import useDynamicLibs from '../common/useDynamicLib.js';

const ExcelExportButton = ({columns = []}) => {
    const [libLoaded, _mods] = useDynamicLibs([import('XlsxPopulate'), import('xlsx') ], ['XlsxPopulate', 'XLSX']);

    if(_mods) {
        window.XlsxPopulate = _mods[0].default;
        window.XLSX = _mods[1].default
    }
    const createDownLoadData = (button) => {
        handleExport(button).then((url) => {
            const downloadAnchorNode = document.createElement('a');
            downloadAnchorNode.setAttribute('href', url);
            downloadAnchorNode.setAttribute('download', `budget_table-${dayjs().format("YYYY-MM-DD-HH-mm-ss")}.xlsx`);
            downloadAnchorNode.click();
            downloadAnchorNode.remove();
        });
    };

    const workbook2blob = (workbook) => {
        const wopts = {
            bookType: 'xlsx',
            bookSST: false,
            type: 'binary',
        };

        const wbout = XLSX.write(workbook, wopts);

        // The application/octet-stream MIME type is used for unknown binary files.
        // It preserves the file contents, but requires the receiver to determine file type,
        // for example, from the filename extension.
        const blob = new Blob([s2ab(wbout)], {
            type: 'application/octet-stream',
        });

        return blob;
    };

    const s2ab = (s) => {
        // The ArrayBuffer() constructor is used to create ArrayBuffer objects.
        // create an ArrayBuffer with a size in bytes
        const buf = new ArrayBuffer(s.length);

        //create a 8 bit integer array
        const view = new Uint8Array(buf);

        //charCodeAt The charCodeAt() method returns an integer between 0 and 65535 representing the UTF-16 code
        for (let i = 0; i !== s.length; ++i) {
            view[i] = s.charCodeAt(i);
        }

        return buf;
    };

    const handleExport = (button) => {
        let parent_element = jQuery(button).parent()
        let table1 = [];
        let header1 = {};
        let header1_cells = parent_element.find('.budget-table .header-row .th')

        for (let i = 65; i < (65 + header1_cells.length); i++) {
            let column = String.fromCharCode(i);
            let value = jQuery(jQuery(header1_cells[i - 65]).find('div:first')[0])?.text();
            header1[column] = {v: value, ct: columns.find(c => c['label'] == value)?.type || 'text'};
        }
        table1.push(header1);

        parent_element.find('.budget-table [role="rowgroup"] .tr').each(function() {
            let row = {};
            let cells = jQuery(this).find('.td');

            for (let i = 65; i < (65 + header1_cells.length); i++) {
                let column = String.fromCharCode(i);
                let value = jQuery(cells[i - 65]).find(':first').context?.innerText;
                row[column] = {v: value, z: formatColumn(header1[column].ct)};
            }
            table1.push(row);
        });

        let table2 = [];
        let header2 = {};
        let header2_cells = parent_element.find('.budget-summary-table .header-row .th');

        for (let i = 65; i < (65 + header2_cells.length); i++) {
            let column = String.fromCharCode(i);
            let value = jQuery(jQuery(header2_cells[i - 65]).find('div:first')[0])?.text();
            header2[column] = {v: value, ct: columns.find(c => c['label'] == value)?.type || 'text'};
        }
        table2.push(header2);

        parent_element.find('.budget-summary-table [role="rowgroup"] .tr').each(function() {
            let row = {};
            let cells = jQuery(this).find('.td');

            for (let i = 65; i < (65 + header2_cells.length); i++) {
                let column = String.fromCharCode(i);
                let value = jQuery(cells[i - 65]).find(':first').context?.innerText;
                row[column] = {v: value, z: formatColumn(header2[column].ct)};
            }
            table2.push(row);
        });

        const table = [{ A: "" }]
            .concat(table1)
            .concat([{ A: "" }])
            .concat(table2);

        const title = [{ A: parent_element.find('.budget-table').closest('.form-viewer').find('.form-title:first')[0]?.innerText || 'BUDGET TABLE' }, {}];
        const finalData = [...title, ...table];

        //create a new workbook
        const wb = XLSX.utils.book_new();

        const sheet = XLSX.utils.json_to_sheet(finalData, {
            skipHeader: true,
        });

        XLSX.utils.book_append_sheet(wb, sheet, 'BUDGET');

        // binary large object
        // Since blobs can store binary data, they can be used to store images or other multimedia files.

        const workbookBlob = workbook2blob(wb);

        const dataInfo = {
            titleCell: 'A2',
            titleRange: `A1:${Object.keys(header1).at(-1)}2`,
            tbodyRange: `A3:${Object.keys(header1).at(-1)}${finalData.length}`,
            theadRange: `A4:${Object.keys(header1).at(-1)}4`,
            tborderRange: `A4:${Object.keys(header1).at(-1)}${table1.length + 3}`,
            theadRange1: `A${table1.length + 5}:${Object.keys(header2).at(-1)}${table1.length + 5}`,
            tborderRange1: `A${table1.length + 5}:${Object.keys(header2).at(-1)}${finalData.length}`,
            hasTable2: !Object.keys(header2).length === 0
        };

        return addStyle(workbookBlob, dataInfo);
    };

    const addStyle = (workbookBlob, dataInfo) => {
        return XlsxPopulate.fromDataAsync(workbookBlob).then((workbook) => {
            workbook.sheets().forEach((sheet) => {

                for (let i = 65; i < 95; i++) {
                    let col = String.fromCharCode(i);
                    sheet.column(col).width(25);
                }

                sheet.row(1).height(50);

                sheet.usedRange().style({
                    fontFamily: 'Arial',
                    verticalAlignment: 'center'
                });

                sheet.range(dataInfo.titleRange).merged(true).style({
                    fontSize: 25,
                    fill: 'F1F1F1',
                    horizontalAlignment: 'center',
                    verticalAlignment: 'center',
                    border: true,
                    borderColor: 'bbbbbb'
                });

                sheet.range(dataInfo.tbodyRange).style({
                    horizontalAlignment: 'center'
                });

                sheet.range(dataInfo.tborderRange).style({
                    border: true,
                    borderColor: 'bbbbbb'
                });

                sheet.range(dataInfo.theadRange).style({
                    fill: 'F1F1F1',
                    bold: true,
                    horizontalAlignment: 'center',
                });
                if(dataInfo.hasTable2){
                    sheet.range(dataInfo.theadRange1).style({
                        fill: 'F1F1F1',
                        bold: true,
                        horizontalAlignment: 'center',
                    });
    
                    sheet.range(dataInfo.tborderRange1).style({
                        border: true,
                        borderColor: 'bbbbbb'
                    });
                }
            });

            return workbook
                .outputAsync()
                .then((workbookBlob) => URL.createObjectURL(workbookBlob));
        });
    };

    const formatColumn = (column_type) => {
        // Column types available:
        // ->> 'text', 'input', 'calculation'

        // Format Types:
        // ->> 'General' == Text
        // ->> '0.00' == Numeric
        return column_type == 'text' ? 'General' : '0.00';
    };

    return (
        <button
            disabled={!libLoaded}
            onClick={(e) => {
                e.preventDefault();
                createDownLoadData(e.currentTarget);
            }}
            className='btn btn-default btn-xs mr-1'
            style={{float: 'right', marginTop: '4px'}}
        >
            <FaIcon type='download' /> {I18n.t('excel_export')}
        </button>
    );
};

export default ExcelExportButton;
